import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { channelOptions, columnsCsv, options } from "./user-contents";

import AllUsersPresentational from "./allusersPresentational";
import { getAllUserList } from "../utils";
import moment from "moment";

const allUsers = () => {
  const history = useHistory();
  const initialChannelState = {
    value: "Direct and Bank Referral",
    label: "Direct and Bank Referral",
  };
  const request = {
    page: 1,
    size: 10,
    name: "",
    mobile: "",
    branchId: "",
    emiratesId: "",
    cardSerialNumber: "",
    fromDate: "",
    toDate: "",
    searchFilter: "",
    applicationId: 1,
    channel: initialChannelState.value,
  };
  const [filterForm, setFilterForm] = useState(request);
  const [modalShow, setModalShow] = useState(false);
  const [searchBy, setSearchBy] = useState("mobile");
  const [searchByValue, setSearchByValue] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState();
  const [blockStatus, setBlockStatus] = useState(false);
  const [verifiedStatus, setVerifiedStatus] = useState(false);
  const [activeStatus, setActiveStatus] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState(false);
  const [filtersSelected, setFiltersSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const [selectedChannelOption, setSelectedChannelOption] =
    useState(initialChannelState);

  const [allUserList, setAllUserList] = useState([]);
  const [allUserListExcel, setallUserListExcel] = useState([]);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const [sizeShow, setSizeShow] = useState();
  const buttonRef = useRef("");

  const columns = [
    {
      dataField: "",
      text: "",
      sort: false,
      style: { minWidth: "50px", textAlign: "center" },
      formatter: (cell, row) => {
        let states = { ...row };
        return (
          <Link
            style={{ color: "black" }}
            to={{
              pathname: "/admin/user-profile",
              state: { id: states.id, rowData: states },
            }}
          >
            <i style={{ fontSize: 18 }} className="fas fa-search" />
          </Link>
        );
      },
    },
    {
      dataField: "citizenId",
      text: "CT ID ",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "fullName",
      text: "Full Name",
      sort: false,
      style: { minWidth: "200px", textAlign: "Left" },
    },
    {
      dataField: "phoneNumber",
      text: "Mobile Number",
      sort: false,
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "branchId",
      text: "Branch Id ",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "companyName",
      text: "Corporate Name",
      sort: false,
      style: { minWidth: "200px", textAlign: "Left" },
    },
    {
      dataField: "emiratesId",
      text: "Emirates Id",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "160px", textAlign: "center" },
    },
    {
      dataField: "cardSerialNo",
      text: "Card Serial Number",
      sort: false,
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "registrationDate",
      text: "Registration Date",
      sort: true,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "220px", textAlign: "center" },
      formatter: (cell, row) => {
        return moment((row && row.registrationDate) || null).format(
          "DD-MM-YY  HH:mm:ss"
        );
      },
    },
    {
      dataField: "verifierName",
      text: "Verified By",
      sort: false,
      style: { minWidth: "150px", textAlign: "left" },
      headerStyle: { textAlign: "left" },
    },

    {
      dataField: "userStatus",
      text: "Account Status",
      sort: false,
      style: { minWidth: "150px", textAlign: "Left" },
    },
  ];

  useEffect(() => {
    if (filterForm) {
      getAllUsers(filterForm);
    }
  }, [filterForm]);

  useEffect(() => {
    setFiltersSelected(true);
    setNoOfFiltersSelected(1); // Added 1 for channel filter by default selected one item at any time and its a single select
  }, []);

  const getAllUsers = (request) => {
    request.size = sizeShow || 10;
    setDataLoading(true);
    getAllUserList(request)
      .then((res) => {
        setDataLoading(false);
        if (res && res.data && res.data.users.length > 0) {
          setAllUserList(() => res.data.users);
        } else {
          setAllUserList([]);
        }
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setPagination({ ...pagination, pageSize: 10, total: 0, current: 1 });
        setDataLoading(false);
        setAllUserList([]);
      });
  };

  const resetFilter = () => {
    setSearchBy("mobile");
    // setSearchByValue('');
    setFiltersSelected(true);
    setNoOfFiltersSelected(1); // Added 1 for channel filter by default selected one item at any time and its a single select
    setAllUserList([]);
    setallUserListExcel([]);
    setFromDate(null);
    setToDate(null);
    setSelectedOption("");
    setSelectedChannelOption(initialChannelState);
    setFilterValues(false);
    setSearchByValue("");
    setFilterForm(request);
  };

  const handleFIlter = () => {
    let request = {};
    if (searchBy === "name") {
      request = {
        ...filterForm,
        name: searchByValue.trim(),
        mobile: "",
        branchId: "",
        emiratesId: "",
        cardSerialNumber: "",
      };
    } else if (searchBy === "mobile") {
      request = {
        ...filterForm,
        mobile: searchByValue.trim(),
        name: "",
        branchId: "",
        emiratesId: "",
        cardSerialNumber: "",
      };
    } else if (searchBy === "branchId") {
      request = {
        ...filterForm,
        branchId: searchByValue.trim(),
        mobile: "",
        name: "",
        emiratesId: "",
        cardSerialNumber: "",
      };
    } else if (searchBy === "emiratesId") {
      request = {
        ...filterForm,
        emiratesId: searchByValue.trim(),
        mobile: "",
        name: "",
        branchId: "",
        cardSerialNumber: "",
      };
    } else if (searchBy === "cardSerialNumber") {
      request = {
        ...filterForm,
        cardSerialNumber: searchByValue.trim(),
        mobile: "",
        name: "",
        branchId: "",
        emiratesId: "",
      };
    } else if (searchBy === "ctid") {
      request = {
        ...filterForm,
        citizenId: searchByValue.trim(),
        mobile: "",
        name: "",
        branchId: "",
        emiratesId: "",
      };
    }
    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate =
      (toDate && moment(toDate).format("YYYY-MM-DD")) || moment().format();
    request.searchFilter = "";
    let a = "";
    if (selectedOption.length > 0) {
      selectedOption.forEach((v, i) => {
        a = a + v.value + (i + 1 < selectedOption.length ? "," : "");
      });
    }
    request.page = 1;
    request.searchFilter = a; // TODO - NEED TO REMOVE
    request.channel = selectedChannelOption.value;

    setFilterForm(request);
  };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedOption([...selectedOption]);
    } else {
      setSelectedOption("");
    }
  };

  const handleChannelChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedChannelOption(selectedOption);
    } else {
      setSelectedChannelOption("");
    }
  };
  const statusFilter = () => {
    setNoOfFiltersSelected(selectedOption.length + 1); // Added 1 for channel filter by default selected one item at any time and its a single select
    setModalShow(false);
    setFiltersSelected(true);
    selectedOption &&
      selectedOption.length > 0 &&
      selectedOption.map((option) => {
        switch (option.label) {
          case "Blocked":
            setBlockStatus(true);
            return setFilterValues(!filterValues);
          case "Verified":
            setVerifiedStatus(true);
            return setFilterValues(!filterValues);
          case "Active":
            setActiveStatus(true);
            return setFilterValues(!filterValues);
          default:
            return "";
        }
      });
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "name") {
    searchByValuePlaceholder = "Amit Pandit";
  } else if (searchBy === "mobile") {
    searchByValuePlaceholder = "971xxxxxxxxx";
  } else if (searchBy === "branchId") {
    searchByValuePlaceholder = "99999";
  } else if (searchBy === "emiratesId") {
    searchByValuePlaceholder = "784xxxxxxxxxxxx";
  } else if (searchBy === "ctid") {
    searchByValuePlaceholder = "784xxxxxxxxxxxx";
  } else {
    searchByValuePlaceholder = "1234567890";
  }

  const onExcelClciked = (filterForm) => {
    let request = filterForm;
    request.page = "";
    request.size = "";
    getAllUserList(request)
      .then((res) => {
        if (res && res.data && res.data.users.length > 0) {
          let data = res.data.users.map((element) => {
            if (element.registrationDate) {
              element.registrationDate = moment(
                element.registrationDate
              ).format("DD-MM-YYYY");
            }
            return element;
          });
          setallUserListExcel(() => data);
          buttonRef.current.click();
        } else {
          setallUserListExcel([]);
        }
      })
      .catch((err) => {
        setallUserListExcel([]);
      });
  };

  const rowOnClick = {
    onClick: (e, row, rowIndex) => {
      history.push({
        pathname: "/admin/user-profile",
        state: { id: row.id, rowData: row },
      });
    },
  };

  return (
    <AllUsersPresentational
      searchBy={searchBy}
      setSearchByValue={setSearchByValue}
      setSearchBy={setSearchBy}
      searchByValuePlaceholder={searchByValuePlaceholder}
      searchByValue={searchByValue}
      fromDate={fromDate}
      rowOnClick={rowOnClick}
      setFromDate={setFromDate}
      toDate={toDate}
      setToDate={setToDate}
      setModalShow={setModalShow}
      filtersSelected={filtersSelected}
      noOfFiltersSelected={noOfFiltersSelected}
      resetFilter={resetFilter}
      handleFIlter={handleFIlter}
      filterValues={filterValues}
      allUserList={allUserList}
      dataLoading={dataLoading}
      buttonRef={buttonRef}
      filterForm={filterForm}
      onExcelClciked={onExcelClciked}
      allUserListExcel={allUserListExcel}
      columns={columns}
      columnsCsv={columnsCsv}
      pagination={pagination}
      setFilterForm={setFilterForm}
      setSizeShow={setSizeShow}
      modalShow={modalShow}
      handleChange={handleChange}
      options={options}
      selectedOption={selectedOption}
      selectedChannelOption={selectedChannelOption}
      channelOptions={channelOptions}
      handleChannelChange={handleChannelChange}
      statusFilter={statusFilter}
    />
  );
};

export default allUsers;
